import { FaBrain } from "react-icons/fa";
import ServiceRow from "./ServiceRow";
import './PsihosocijalniRizici.css'

export default function PsihosocijalniRizici() {
    return (
        
        <ServiceRow
        id='psihosocijalni'
            icon={<FaBrain />}
            title="Практична обука за психосоцијални ризици и превенција од burnout"
        >
            <p className="intro-text">
                Во современата работна средина, психолошките ризици – како стрес, прегорување (burnout)
                и емоционална исцрпеност – се меѓу водечките причини за намалена продуктивност,
                боледувања и флуктуација на кадар.
            </p>

            <p className="intro-text">
                Нашата еднодневна практична обука е дизајнирана да им помогне на компаниите навремено
                да ги препознаат, менаџираат и превенираат психолошките ризици, со фокус на burnout
                како клучен организациски предизвик.
            </p>

            {/* GRID */}
            <div className="mini-grid">

                <div className="mini-card">
                    <h4>🎯 Цел на обуката</h4>
                    <ul className="service-list">
                        <li><span className="check">✓</span> Препознавање на рани знаци на burnout</li>
                        <li><span className="check">✓</span> Разбирање на психолошките ризици</li>
                        <li><span className="check">✓</span> Јакнење на улогата на менаџерите</li>
                        <li><span className="check">✓</span> Подобрување на комуникацијата во тимови</li>
                        <li><span className="check">✓</span> Намалување на отсуства и стрес</li>
                    </ul>
                </div>

                <div className="mini-card">
                    <h4>👥 За кого е наменета?</h4>
                    <ul className="service-list">
                        <li><span className="check">✓</span> Менаџери и тим лидери</li>
                        <li><span className="check">✓</span> HR оддели</li>
                        <li><span className="check">✓</span> Раководни структури</li>
                        <li><span className="check">✓</span> Компании со wellbeing стратегии</li>
                    </ul>
                </div>

                <div className="mini-card">
                    <h4>📚 Содржина на обуката</h4>
                    <ul className="service-list">
                        <li><span className="check">✓</span> Психосоцијални ризици</li>
                        <li><span className="check">✓</span> Стрес и организациски фактори</li>
                        <li><span className="check">✓</span> Burnout – фази и симптоми</li>
                        <li><span className="check">✓</span> Улога на менаџерот</li>
                        <li><span className="check">✓</span> Превенција и организациски мерки</li>
                        <li><span className="check">✓</span> Case studies и практични вежби</li>
                    </ul>
                </div>

                <div className="mini-card">
                    <h4>🧑‍⚕️ Начин на спроведување</h4>
                    <ul className="service-list">
                        <li><span className="check">✓</span> Лиценциран психолог</li>
                        <li><span className="check">✓</span> On-site во компанија</li>
                        <li><span className="check">✓</span> 10–20 учесници</li>
                        <li><span className="check">✓</span> Интерактивни вежби</li>
                    </ul>
                </div>

                {/* 🧑‍⚕️ СПРОВЕДУВАЊЕ */}
                <div className="mini-card">
                    <h4>🧑‍⚕️ Начин на спроведување</h4>
                    <ul className="service-list">
                        <li><span className="check">✓</span> Лиценциран психолог со корпоративно искуство</li>
                        <li><span className="check">✓</span> On-site во компанијата</li>
                        <li><span className="check">✓</span> 10–20 учесници</li>
                        <li><span className="check">✓</span> Интерактивни дискусии и вежби</li>
                    </ul>
                </div>


                {/* ⏱️ ВРЕМЕ */}
                <div className="mini-card">
                    <h4>⏱️ Времетраење</h4>
                    <ul className="service-list">
                        <li><span className="check">✓</span> 1 работен ден (6–8 часа)</li>
                    </ul>
                </div>


                {/* 📊 КОМПАНИЈА */}
                <div className="mini-card">
                    <h4>📊 Што добива компанијата?</h4>
                    <ul className="service-list">
                        <li><span className="check">✓</span> Препознавање на ризици</li>
                        <li><span className="check">✓</span> Превенција на burnout</li>
                        <li><span className="check">✓</span> Подобра тимска динамика</li>
                        <li><span className="check">✓</span> Помалку боледувања</li>
                    </ul>
                </div>


                {/* 📜 СЕРТИФИКАТ */}
                <div className="mini-card">
                    <h4>📜 Сертификат</h4>
                    <ul className="service-list">
                        <li><span className="check">✓</span> Сертификат за учество</li>
                        <li><span className="check">✓</span> Практични материјали</li>
                    </ul>
                </div>


                {/* 🚀 ДОДАДЕНА ВРЕДНОСТ */}
                <div className="mini-card">
                    <h4>🚀 Додадена вредност</h4>
                    <ul className="service-list">
                        <li><span className="check">✓</span> Проценка на ризици</li>
                        <li><span className="check">✓</span> Систематски прегледи</li>
                        <li><span className="check">✓</span> Лидерство и комуникација</li>
                    </ul>
                </div>


            </div>
            {/* 📚 СОДРЖИНА */}
      {/* 📚 СОДРЖИНА */}
<div className="mini-card full-width">
  <h4>📚 Содржина на обуката</h4>

  <p className="intro-text">
    Обуката е интерактивна и практично ориентирана, со реални примери од работната средина.
  </p>

  <div className="modules-grid">

    {/* LEFT COLUMN */}
    <div className="module-card">
      <h5>🔹 Модул 1: Психолошки ризици</h5>
      <ul className="service-list">
        <li><span className="check">✓</span> Психосоцијални ризици</li>
        <li><span className="check">✓</span> Стрес и притисок</li>
        <li><span className="check">✓</span> Влијание врз продуктивност</li>
      </ul>
    </div>

    <div className="module-card">
      <h5>🔹 Модул 2: Burnout</h5>
      <ul className="service-list">
        <li><span className="check">✓</span> Фази и симптоми</li>
        <li><span className="check">✓</span> Стрес vs burnout</li>
        <li><span className="check">✓</span> Ризични групи</li>
      </ul>
    </div>

    {/* RIGHT COLUMN */}
    <div className="module-card">
      <h5>🔹 Модул 3: Улога на менаџерот</h5>
      <ul className="service-list">
        <li><span className="check">✓</span> Рани сигнали</li>
        <li><span className="check">✓</span> Комуникација со вработени</li>
        <li><span className="check">✓</span> Практична поддршка</li>
      </ul>
    </div>

    <div className="module-card">
      <h5>🔹 Модул 4–5</h5>
      <ul className="service-list">
        <li><span className="check">✓</span> Организациски мерки</li>
        <li><span className="check">✓</span> Case studies</li>
        <li><span className="check">✓</span> Role-play вежби</li>
      </ul>
    </div>

  </div>
</div>


            {/* BOTTOM SECTION */}
            <div className="bottom-box">
                <h4>📊 Што добива компанијата?</h4>
                <div className="pill-list">
                    <span>Обучени менаџери за препознавање ризици </span>
                    <span> Практични алатки за превенција на burnout</span>

                    <span> Подобрена тимска динамика</span>
                    <span> Намалено боледување и флуктуација</span>

                </div>
            </div>

        </ServiceRow>
    );
}